module.exports = __webpack_public_path__ + "static/media/CTLA_10-475w.eb159fd6.webp";